export const GET_TRANSACTION_TYPE ='GET_TRANSACTION_TYPE';